import { COLORS } from '../constants';
import { ApplicationPropertyVO } from '../../../../../hooks/useApplicationProperties';

/**
 * Get text color for archived items
 */
export const getArchivedTextColor = (): string => {
  return COLORS.ARCHIVED_TEXT;
};

/**
 * Get text color for non-archived items
 */
export const getNonArchivedTextColor = (): string => {
  return COLORS.NON_ARCHIVED_TEXT;
};

/**
 * Get field icon color for archived items
 */
export const getArchivedFieldIconColor = (): string => {
  return COLORS.ARCHIVED_FIELD_ICON;
};

/**
 * Get field icon color for non-archived items
 */
export const getNonArchivedFieldIconColor = (): string => {
  return COLORS.NON_ARCHIVED_FIELD_ICON;
};

/**
 * Sort items by archived status (non-archived first)
 */
export const sortByArchivedStatus = <T extends { archived: boolean }>(
  items: T[]
): T[] => {
  return items.sort((a, b) => {
    if (a.archived === b.archived) return 0;
    return a.archived ? 1 : -1;
  });
};

/**
 * Pluralize a word based on count
 */
export const pluralize = (
  count: number,
  singular: string,
  plural?: string
): string => {
  if (count === 1) return singular;
  return plural || `${singular}s`;
};

/**
 * Filter properties based on search term
 * Searches across farm name, field name, crop zone name, and crop name
 */
export const filterPropertiesBySearch = (
  properties: ApplicationPropertyVO[],
  searchTerm: string
): ApplicationPropertyVO[] => {
  if (!searchTerm || searchTerm.trim() === '') {
    return properties;
  }

  const lowerSearch = searchTerm.toLowerCase().trim();

  return properties.filter(property => {
    const searchableFields = [
      property.farmName,
      property.fieldName,
      property.cropZoneName,
      property.cropName
    ];

    return searchableFields.some(field =>
      field.toLowerCase().includes(lowerSearch)
    );
  });
};
